/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BankAccount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PaymentProviderMethod from 'DesignSystem/PaymentProvider/PaymentProviderMethod/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BankAccount({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content/ChooseAutopaySource/Content/AutopaySourceDetails/BankAccount"
  
}) {
let editAutopayInfoLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'location._id',
})
let editAutopayInfoReceivablePaymentAccountPersonPaymentAccountPayerPersonValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'receivable.payment_account.person_payment_account.payer_person',
})
  return (<React.Fragment
>
<div
  data-testid="BankAccount.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<PaymentProviderMethod
  viewPath={`${viewPath}/PaymentProviderMethod`}
 method="ach"
 data="edit_autopay_info.location._id"
 locationId={editAutopayInfoLocationIdValueData}
 data="edit_autopay_info.receivable.payment_account.person_payment_account.payer_person"
 person={editAutopayInfoReceivablePaymentAccountPersonPaymentAccountPayerPersonValueData}
/>
</div>
{children}
</React.Fragment>)
}